var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileAttachement = function SvgFileAttachement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file-attachement_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M12.286 13.143V3.429A2.857 2.857 0 0 0 9.429.57H6.57A2.857 2.857 0 0 0 3.714 3.43v9.714A2.286 2.286 0 0 0 6 15.429h1.143a2.286 2.286 0 0 0 2.286-2.286V4.57A1.143 1.143 0 0 0 8.286 3.43h-.572A1.143 1.143 0 0 0 6.571 4.57v6.286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file-attachement_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFileAttachement;